<template>
    <div class="tools-tab tools-tab-tags">
        <span>Project toewijzen aan deze Dienst</span><br>
        <em>Current Project: {{ selectedProject ? selectedProject.name : 'None' }}</em>

        <ul class="list list-tags" v-if="projects && projects.length">
            <li v-for="project in projects"
                :key="project.id"
                :class="{ 'is-active': isSelected(project) }"
                @click="handleSelection(project)"
            >
                <span>{{ project.name }}
                    <span style="font-size: 12px !important; font-style: italic !important;">
                        ({{ project.code }})
                    </span>
                </span>
                <icon name="cancel" v-if="isSelected(project)" />
                <icon name="check" v-else />
            </li>
        </ul>

        <div class="empty" v-else>
            {{ $t('page.roster.tools.projects_none') }}
        </div>
    </div>
</template>

<script>
import shared from '../../../pages/planning/shared';
import _ from 'lodash';
import moment from 'moment';

export default {
    name: 'Projects',

    props: ['item'],  // The roster item to assign a project to

    data() {
        return {
            shared: shared.state,
            selectedProject: null
        };
    },

    computed: {
        projects() {
            return this.shared.projects;
        }
    },

    mounted() {
        // Preselect the current project if available
        if (this.item.project && this.item.project.id) {
            const p = _.find(this.projects, {name: this.item.project.name});
            if (p) {
                this.selectedProject = p;
            }
        }
    },

    watch: {
        /**
         * Watch for changes in item.project and update selectedProject accordingly
         */
        item: {
            immediate: true, // Trigger on initial load
            handler(newItem) {
                if (newItem.project && newItem.project.id) {
                    const existingProject = _.find(this.projects, { id: newItem.project.id });
                    if (existingProject) {
                        this.selectedProject = existingProject;
                    }
                }
            }
        }
    },

    methods: {
        /**
         * Check if a project is currently assigned to the item.
         */
        isSelected(project) {
            return this.selectedProject && this.selectedProject.id === project.id;
        },

        /**
         * Handle the selection/deselection of a project.
         */
        handleSelection(project) {
            if (this.isSelected(project)) {
                this.$confirm.show(
                    this.$t('Are you sure you want to unassign this project?'),
                    '',
                    {
                        confirm: () => this.unassignProject(),
                        decline: () => {
                        } // Do nothing on decline
                    }
                );
            } else {
                this.$confirm.show(
                    this.$t('Are you sure you want to assign this project?'),
                    '',
                    {
                        confirm: () => this.assignProject(project),
                        decline: () => {
                        } // Do nothing on decline
                    }
                );
            }
        },

        /**
         * Assigns the selected project to the item via an API call.
         */
        assignProject(project) {
            this.$http.post('/api/roster/assign-project', {
                project_id: project.id,
                item_id: this.item.id
            })
                .then(() => {
                    this.selectedProject = project;
                    this.$notify.success(this.$t('Project assigned successfully.'));
                    window.location.reload(true);
                })
                .catch(() => {
                    this.$notify.error(this.$t('Error assigning project.'));
                });
        },

        /**
         * Unassigns the project from the item via an API call.
         */
        unassignProject() {
            this.$http.post('/api/roster/unassign-project', {
                item_id: this.item.id
            })
                .then(() => {
                    this.selectedProject = null;
                    this.$notify.success(this.$t('Project unassigned successfully.'));
                    window.location.reload(true);
                })
                .catch(() => {
                    this.$notify.error(this.$t('Error unassigning project.'));
                });
        },

        /**
         * Formats the date in DD MMM format.
         */
        getDate(date) {
            return moment(date).format('DD MMM');
        }
    }
};
</script>



// WEBPACK FOOTER //
// Project.vue?47f6b637